export const PROCESSING_CODES = {
  rush: "RUSH",
  standard: "STANDARD",
  leadDiscount: "LEAD_DISCOUNT",
  leadDiscount20: "LEAD_DISCOUNT_20",
  leadDiscount50: "LEAD_DISCOUNT_50",
  oneHour: "ONE_HOUR",
};
